import { FormikErrors, useFormik } from 'formik';
import React, { useEffect } from 'react';
import VoxelInput from '../../../components/voxel/Forms/VoxelInput';
import VoxelFormPanel from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanel';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { projectsApiService } from '../../../graphql/projects/projectsApiService';
import VoxelPanelActions from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelPanelActions';
import VoxelFormPanelActionSubmit from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelActionSubmit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/pro-regular-svg-icons';
import VoxelFormPanelContent from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelContent';

export interface FormState {
  name: string;
}

export interface ProjectNameFormProps {
  project: ProjectGq;
  setDirty: (dirty: boolean) => void;
  reload: () => Promise<unknown>;
  setSave: (saveFunction: () => Promise<unknown>) => void;
}

const ProjectNameForm: React.FC<ProjectNameFormProps> = ({
  project,
  setDirty,
  reload,
  setSave,
}) => {
  const mutation = projectsApiService.mutations.projects.useUpdateProjectName();
  const formikProps = useFormik<FormState>({
    initialValues: {
      name: project.name,
    },
    validate: (values) => {
      const errors: FormikErrors<FormState> = {};
      if (!(values.name.length > 0)) {
        errors.name = `Field cannot be empty`;
      }
      return errors;
    },
    enableReinitialize: true,
    onSubmit: (values, actions) =>
      mutation({ id: project.id, name: values.name })
        .catch((error) => console.log(error))
        .then(() => reload()),
  });

  useEffect(() => setSave(formikProps.submitForm), [formikProps.submitForm]);
  useEffect(() => {
    setDirty(formikProps.dirty);
    return () => setDirty(false);
  }, [formikProps.dirty]);

  return (
    <VoxelFormPanel title={<span>Project name</span>}>
      <VoxelFormPanelContent>
        <VoxelInput
          id="projectName"
          placeholder={'Example project'}
          value={formikProps.values.name}
          onChange={(event) => formikProps.setFieldValue('name', event.target.value)}
          deleteValue={() => formikProps.setFieldValue('name', '')}
          helperText={formikProps.errors?.name}
          showHelperText={!!formikProps.errors?.name?.length}
          disabled={formikProps.isSubmitting}
        />
      </VoxelFormPanelContent>
      <VoxelPanelActions>
        <VoxelFormPanelActionSubmit
          title={'Save changes'}
          onClick={formikProps.submitForm}
          disabled={formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty}
          endIcon={<FontAwesomeIcon icon={faSave} />}
        />
      </VoxelPanelActions>
    </VoxelFormPanel>
  );
};

export default ProjectNameForm;
